var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValuesMobileSplat1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 1429,
    viewBox: "0 0 375 1429",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1003_3272)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.452 449.71C367.399 458.287 419.402 446.187 465.328 467.613C515.159 490.86 559.496 526.9 586.084 575.031C613.777 625.162 617.522 683.401 616.159 740.656C614.647 804.131 633.312 892.483 577.792 923.291C514.514 958.404 439.613 856.88 370.147 877.168C300.864 897.403 290.695 1044.75 220.581 1027.62C152.201 1010.91 204.583 887.474 167.49 827.65C139.598 782.665 56.5757 787.991 40.6981 737.499C25.2387 688.337 80.6451 645.553 94.6305 595.951C112.111 533.954 79.0368 445.872 132.889 410.528C186.555 375.306 254.186 438.846 317.452 449.71Z",
    fill: "url(#paint0_linear_1003_3272)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1003_3272",
    x: -362,
    y: 0,
    width: 1380,
    height: 1429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_1003_3272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1003_3272",
    x1: -7.87881,
    y1: 1095.4,
    x2: 671.538,
    y2: 426.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0398851,
    stopColor: "#D05731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F64E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuesMobileSplat1);
export default __webpack_public_path__ + "static/media/values_mobile_splat_1.ca19dcba8a6c6f8adbd466ba47418d77.svg";
export { ForwardRef as ReactComponent };